import { generateUuid } from '@utils/helpers'
import { parseOptions } from './helpers'
import { EVENT_MODAL_SHOW, EVENT_MODAL_HIDE } from './constants'

export class ModalMaker {
  constructor(vm, _options) {
    this._vm = vm
    this._root = vm.$root

    /**
     * Unique id of the toast
     */
    this.id = generateUuid()

    /**
     * Shared Options of the Toast
     */
    this.options = parseOptions(_options)
  }

  ensureModalRootWrapper() {
    if (!document.querySelectorAll('.modal-outer').length) {
      const div = document.createElement('div')
      div.className = '_modal-root'
      document.body.appendChild(div)
    }
  }

  show(id, options = {}) {
    const _options = {...this.options, ...options}
    this.ensureModalRootWrapper()
    this._root.$emit(EVENT_MODAL_SHOW, { id, options: _options })
  }

  hide(id, options = {}) {
    const _options = {...this.options, ...options}
    this.ensureModalRootWrapper()
    this._root.$emit(EVENT_MODAL_HIDE, { id, options: _options })
  }
}
